import React, { Component, createRef } from "react";
import {
  POST,
  loading,
  alert,
  mode,
  setDarkMode,
  params,
} from "../components/CustomComponent.js";
import Turnstile from "react-turnstile";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: params("email") || "",
      token: "",
      captchaKey: Date.now(),
    };
    this.turnstileRef = createRef();
  }
  componentDidMount() {
    if (mode === "dark") {
      setDarkMode();
    }
    loading(false);
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
  }
  ResetPassword = async () => {
    const { token, email } = this.state;
    if (!token) {
      alert("", "warning", "Warning", "Please confirm CAPTCHA.");
      return;
    }
    if (!email?.trim()) {
      alert("", "warning", "Warning", "Please input Email");
      return;
    }
    loading(true);
    let result = await POST("v1/public/reset-password", {
      email: email,
      token: token,
    });
    if (result?.status) {
      alert(
        "/",
        "success",
        "Success",
        "We’ve sent a reset password link to your email"
      );
    } else {
      this.setState({ token: "", captchaKey: Date.now() });
    }
    loading(false);
  };

  render() {
    const { token } = this.state;
    return (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div
            className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}
          >
            <img
              alt="logo"
              src={LOGO}
              className="w-75"
              style={{ minWidth: 350 }}
            />
          </div>
          <div
            className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}
          >
            <img
              alt="logo"
              src={LOGO}
              style={{ width: "60%", minWidth: 400 }}
            />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5 auth-card">
              <h3 className="fw-bold text-dark mb-3">Reset Password</h3>
              <div className="mb-3">
                <small>
                  Didn’t get the email? Click below to reset password.
                </small>
              </div>
              <label className="mb-1">Email</label>
              <input
                className="form-control mb-3"
                type="text"
                placeholder="Email"
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                value={this.state.email}
              />
              <div className="w-100 mb-2">
                <Turnstile
                  key={this.state.captchaKey}
                  size="flexible"
                  sitekey={process.env.REACT_APP_CLOUDFLARE_SITE_KEY}
                  onVerify={(token) => {
                    this.setState({ token });
                  }}
                  onExpire={() => {
                    this.setState({ token: "" });
                  }}
                />
              </div>
              <button
                type="button"
                className={`btn ${
                  token ? "btn-dark" : "btn-secondary"
                } w-100 mb-3`}
                onClick={() => {
                  this.ResetPassword();
                }}
                disabled={!token}
              >
                Send mail
              </button>
              <div className="w-100 text-center">
                <small className="text-secondary text-center">
                  Copyright © 2025 SwiftGoldPay version {global.version}
                </small>
                <br />
                <br />
                <a href="/" className="text-decoration-none text-dark">
                  Return to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
